/* eslint-disable no-underscore-dangle */
import http from '@/tool/http/http'

function service() {
  const Services = {}
  // 各用工单位岗位发布数量统计
  Services._jobCountList = data => http.POST('/api/data/jobCountList/', data)
  // 各岗位发放报酬合计金额
  Services._jobMonthMoneyList = data => http.POST('/api/data/jobMonthMoneyList', data)
  // 各用工单位在岗学生人数统计
  Services._studentCountList = data => http.POST('/api/data/studentCountList', data)
  // 各用工单位发放报酬合计金额
  Services._unitMonthMoneyList = data => http.POST('/api/data/unitMonthMoneyList', data)
  // 查询在岗人数和岗位数
  Services._jobQueryNumber = data => http.POST('/api/jobs/statictis/jobQueryNum', data)
  // 查询单位统计
  Services._getUnitStatistics = data => http.POST('/api/units/getUnitStatistics', data)
  // 分页查询岗位统计信息
  Services._jobQueryForPage = data => http.POST('/api/jobs/statictis/jobQueryForPage', data)
  return Services
}
export default service
